// extracted by mini-css-extract-plugin
export default {"root":"_5F0zX","indicators":"_28kRh"};